import type { AxiosInstance, AxiosResponse } from 'axios'
import { makeAxiosInstance } from 'mailup-react-helpers'

import { beAccountSettingsApiGetSessionOauth2Token } from 'Api/beAccountSettingsApi'

import { APP_CLIENT_ID } from 'Constants'
import { logApiError, logApiTiming } from './logger'

const refreshToken = async (seckey: string): Promise<string> => {
  const { token } = await beAccountSettingsApiGetSessionOauth2Token({
    seckey,
    client_id: APP_CLIENT_ID,
    force: true,
  })

  return token
}

const apiWrapper: AxiosInstance = makeAxiosInstance({
  refreshToken,
  apiTimeLog: logApiTiming,
  apiErrorLog: logApiError,
})
export default apiWrapper

export const extractApiData = (r: AxiosResponse): any => r.data
